module.exports = __webpack_public_path__ + "img/step1.f8bb50f9.png";